import { API_BASE_URL, apiGet, apiPost, apiPut } from '@/api/http';

import type { Specialization } from '@/types/reference';

export const getSpecializationList = () =>
  apiGet<Specialization[]>(`${API_BASE_URL}specializations/`);

export const createSpecialization = (name: string) =>
  apiPost<Specialization>(`${API_BASE_URL}specializations/`, { name });

export const setSpecializationList = (specializationIds: string[]) =>
  apiPut(`${API_BASE_URL}recruiters/me/specializations/`, {
    specializations: specializationIds,
  });
